// Because of JS import hoisting, we need this init code to be here,
// so that following imports in application.js have access to `Rails`

import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;
